<script lang="ts">
    import type {
        EnvHwFulll,
        EnvHw_HwStandart,
        EthanolDes,
        GroupDesMes,
        MesurmentDataPoint,
        MesurmentEnv,
        OvenDes,
        WikaDes,
    } from "../script/types";
    import { EnvHwStore, GroupStore } from "../script/probeStore";

    import SmallTable from "../wrapElement/SmallTable.svelte";
    import { onDestroy } from "svelte";
    import BoxedVal from "./BoxedVal.svelte";
    import Select from "../leafElement/Select.svelte";
    import Label from "../leafElement/Label.svelte";
    import Data from "./Data.svelte";
    import Input from "../leafElement/Input.svelte";
    import { SPort, UserCredential } from "../script/store";
    import { WikaParser } from "./dataParser";
    import type { MesurmentEnviromentOut } from "../script/requestTypes";
    import TripleCounter from "./sub/TripleCounter.svelte";
    import { pushNewEnviroment } from "../script/din/dataBroker";
    import { ENV_HW_KEYS } from "../script/enum";
    import { writable } from "svelte/store";

    interface BaseEnvDes {
        name: string;
        dispOvenList: OvenDes[];
        defaultSelect: {
            oven: OvenDes;
            wika: WikaDes;
            ethanol: EthanolDes;
        };
    }

    interface EnvTileDes {
        meta: {
            uid: number;
            displayedId: string;
            editMode: boolean;
            tipleCountData: { temp: number; state: number }[];
        };
        data: MesurmentEnv;
        avalible: {
            wika: {
                name: string;
                value: any;
            }[];
            ethanol: {
                name: string;
                value: any;
            }[];
            group: {
                name: string;
                value: any;
            }[];
            oven: {
                name: string;
                value: any;
            }[];
            location: {
                name: string;
                value: any;
            }[];
        };
    }

    interface SelectEnvHw {
        name: string;
        value: {
            dbUid: number;
            value: EnvHwFulll;
        };
    }

    const envHwDestructorList = [];

    let wika_ES: SelectEnvHw[] = [];
    envHwDestructorList.push(
        EnvHwStore.subscribe(ENV_HW_KEYS.wika, (list) => {
            wika_ES = list.map(parseToSelect);
        })
    );

    let ethanol_ES: SelectEnvHw[] = [];
    envHwDestructorList.push(
        EnvHwStore.subscribe(ENV_HW_KEYS.etalon, (list) => {
            ethanol_ES = list.map(parseToSelect);
        })
    );

    let oven_ES: SelectEnvHw[] = [];
    envHwDestructorList.push(
        EnvHwStore.subscribe(ENV_HW_KEYS.owen, (list) => {
            oven_ES = list.map(parseToSelect);
        })
    );

    let location_ES: SelectEnvHw[] = [];
    envHwDestructorList.push(
        EnvHwStore.subscribe(ENV_HW_KEYS.location, (list) => {
            location_ES = list.map(parseToSelect);
        })
    );

    function parseToSelect(val: EnvHwFulll): {
        name: string;
        value: {
            dbUid: number;
            value: EnvHwFulll;
        };
    } {
        return {
            name: val.name,
            value: {
                dbUid: val.dbUid,
                value: val,
            },
        };
    }

    /* ================ WIKA ============== */

    let wikaPortList = [
        {
            dbUid: 0,
            displayedId: "Vstup A",
            val: null,
        },
        {
            dbUid: 1,
            displayedId: "Vstup B",
            val: null,
        },
    ];
    let Wika: WikaParser;
    let wikaReadEnable;
    $: wikaReadEnable = Boolean(Wika);
    const sPortSubscrition = SPort.subscribe((newPort) => {
        if (Wika) {
            Wika.clear();
            Wika = null;
        }
        if (!newPort) {
            return;
        }
        Wika = new WikaParser(newPort, (newMsg) => {
            const portIndex = newMsg.portParsed === 1 ? 0 : 1;
            if (wikaPortList[portIndex]) {
                wikaPortList[portIndex].val = newMsg.val;
            }
        });
        Wika.startRequestTimer(["1", "2"]); // DEV !!! - start in DATA
    });

    /* ================ GROUP ============== */

    let avalibleGroups: GroupDesMes[] = [];
    let group_ES: { name: string; value: GroupDesMes }[];
    $: group_ES = avalibleGroups.map((val) => ({
        name: `skupina: ${val.displayedId}`,
        value: val,
    }));
    envHwDestructorList.push(
        GroupStore.subscribeList((groupList) => {
            avalibleGroups = groupList;
        })
    );

    /* ================ ENV ============== */
    let allUsedEnv: EnvTileDes[] = [];
    const envObesrvable = writable<MesurmentEnv>(null);
    export let usedEnv: EnvTileDes | null = null;
    let usedEnvId: number = NaN;
    function updateDataEnv(env: EnvTileDes) {
        if (env) {
            envObesrvable.set(env.data);
        }
    }

    let avalibleEnv_Table = [];
    $: {
        avalibleEnv_Table = oven_ES.map((val, i) => {
            return {
                showHeadder: i == 0 ? true : false,
                row: [
                    {
                        title: "Jméno",
                        val: val.name,
                    },
                    /* {
                        title: "ID",
                        val: val.value.value.metaData
                            ? (val.value.value.metaData as EnvHw_HwStandart)
                                  .evidenceNumber
                            : "",
                    }, */
                    {
                        title: "Pozn.",
                        val:
                            val.value.value.metaData &&
                            (val.value.value.metaData as EnvHw_HwStandart).note
                                ? (val.value.value.metaData as EnvHw_HwStandart)
                                      .note
                                : "-",
                    },
                ],
            };
        });
    }

    let avalibleGroup_STable = [];
    $: {
        avalibleGroup_STable = avalibleGroups.map((val, i) => {
            return {
                showHeadder: i == 0 ? true : false,
                row: [
                    {
                        title: "Jméno",
                        val: val.displayedId,
                    },
                    {
                        title: "Počet",
                        val: val.merurmentList.length,
                    },
                ],
                hiden: {
                    groupId: val.uid,
                },
            };
        });
    }
    let avalibleGroup_STableFun = {
        data: [
            /* {
                icon: "edit",
                disabled: true,
                action: (id, rowObj) => {
                    console.log(id, rowObj);
                },
            }, */
            {
                icon: "delete",
                action: (id, rowObj) => {
                    console.log(id, rowObj);
                    GroupStore.rm(rowObj.hiden.groupId);
                },
            },
        ],
    };

    let envTempreture = null;
    let envHumidity = null;
    /* let envTempreture = 0;
    let envHumidity = 0; */

    let envCounter = 1;
    let disableEnvAdd;
    $: disableEnvAdd = Boolean(
        wika_ES.length === 0 ||
            ethanol_ES.length === 0 ||
            oven_ES.length === 0 ||
            allUsedEnv.length >= avalibleGroup_STable.length
    );
    function addEnv() {
        if (disableEnvAdd) return; // TODO here?
        const newEnv = {
            meta: {
                uid: envCounter,
                displayedId: `S:${envCounter.toString().padStart(2, "0")}`,
                editMode: true,
                tipleCountData: [],
            },
            /* data: {
                wika: null,
                ethanol: null,
                oven: null,
                location: null,
                group: null,
            }, */
            data: {
                wika: wika_ES.length !== 0 ? wika_ES[0].value : null,
                ethanol: ethanol_ES.length !== 0 ? ethanol_ES[0].value : null,
                oven: oven_ES.length !== 0 ? oven_ES[0].value : null,
                location:
                    location_ES.length !== 0 ? location_ES[0].value : null,
                group: null,
            },
            avalible: {
                wika: wika_ES,
                ethanol: ethanol_ES,
                oven: oven_ES,
                location: location_ES,
                group: [],
            },
        };
        allUsedEnv.push(newEnv);
        updateAllEnv();
        /* newEnv.data.group =
            newEnv.avalible.group.length !== 0
                ? newEnv.avalible.group[0]
                : null; */
        envCounter++;
        allUsedEnv = [...allUsedEnv];
    }
    function updateAllEnv() {
        const allSelected = allUsedEnv
            .map((env) => env.data.group)
            .filter((group) => Boolean(group));
        allUsedEnv.forEach((env) => {
            env.avalible.group = group_ES.filter((group) =>
                Boolean(
                    group.value === env.data.group ||
                        !allSelected.includes(group.value)
                )
            );
        });
    }
    function rmEnv(env: EnvTileDes) {
        for (let i = 0; i < allUsedEnv.length; i++) {
            if (env.meta.uid === allUsedEnv[i].meta.uid) {
                allUsedEnv.splice(i, 1);
            }
        }
        if (usedEnvId === env.meta.uid) {
            usedEnvId = NaN;
            usedEnv = null;
            // updateDataEnv(); //TODO NEED?
        }
        allUsedEnv = [...allUsedEnv];
    }

    function displayEnv(env: EnvTileDes) {
        if (env.meta.editMode) {
            return;
        }
        usedEnvId = env.meta.uid;
        usedEnv = env;
        updateDataEnv(env);
    }
    function changeEnvEnableMode(env: EnvTileDes, newMode: boolean) {
        env.meta.editMode = newMode;
        if (newMode && usedEnvId === env.meta.uid) {
            usedEnvId = NaN;
            usedEnv = null;
        }
        if (!newMode && isNaN(usedEnvId)) {
            displayEnv(env);
        }
        if (!newMode) {
            env.meta.tipleCountData = env.data.group.targetDataPoints.map(
                (dp) => {
                    return {
                        temp: dp.temp,
                        state: dp.state,
                    };
                }
            );
            const curentUser = UserCredential.getUserInfo();
            const envUpdateRequests = env.data.group.merurmentList.map(
                (mes) => {
                    const envData: MesurmentEnviromentOut = {
                        measurement_dbUid: mes.dbUid,
                        wika_dbUid: env.data.wika.dbUid,
                        etalon_dbUid: env.data.wika.dbUid,
                        oven_dbUid: env.data.oven.dbUid,
                        location_dbUid: env.data.location.dbUid,
                        locationByValue: null,
                        labMeta: {
                            temperature: envTempreture,
                            humidity: envHumidity,
                        },
                    };
                    return pushNewEnviroment(envData);
                }
            );
            const promise = Promise.all(envUpdateRequests);
        }
    }

    /* TODO TODO TODO TODO TODO */
    function onNewDataPoint(param) {
        if (!usedEnv) return;
        const data = param.detail;
        allUsedEnv
            .filter((env) => env.meta.uid === usedEnvId)
            .forEach((env) => {
                env.meta.tipleCountData = env.meta.tipleCountData.map((val) => {
                    if (val.temp === data.temp) {
                        val.state = data.val;
                    }
                    return val;
                });
            });

        allUsedEnv = [...allUsedEnv];
    }

    function cleanUp() {
        sPortSubscrition();
        if (Wika) {
            Wika.clear();
        }
        envHwDestructorList.forEach((call) => {
            call();
        });
    }
    onDestroy(cleanUp);
</script>

<div class="root">
    <div class="formDivider" style="padding-top: 3rem;">
        <p>Zdroje</p>
        <div />
    </div>
    <div class="inputList">
        <div>
            <p class="bigText">Wika</p>
            <div class="borderBox">
                {#if wikaReadEnable}
                    <div class="standartFilledMesage neutralColors">
                        <span class="material-icons"> check_circle </span>
                        <span>Připojeno</span>
                    </div>
                    <div class="wikaValList">
                        {#each wikaPortList as val, i}
                            <div>
                                <BoxedVal
                                    title={val.displayedId}
                                    val={val.val}
                                    autoDisable={true}
                                />
                            </div>
                        {/each}
                    </div>
                {:else}
                    <div class="standartFilledMesage errorColors">
                        <span class="material-icons"> report </span>
                        <span>Nepřipojeno</span>
                    </div>
                    <a class="sgButton" href="#wikaSetting">
                        <span class="material-icons-outlined"> usb </span>
                        <span>Připojení</span>
                    </a>
                {/if}
            </div>
        </div>
        <div>
            <p class="bigText">Prostředí</p>
            <div class="borderBox">
                <div class="defaultEnvWrap">
                    <!--  <div class="defaultEnvSelect">
                        <Select
                            name={"Prostředí"}
                            bind:userSelected={baseEnv}
                            optionsList={baseEnv_ES}
                        />
                    </div> -->
                    <div class="defaultEnvParam">
                        <Input
                            bind:val={envTempreture}
                            inputType={"number"}
                            name={"Teplota Prostředí"}
                            required={true}
                        />
                        <Input
                            bind:val={envHumidity}
                            inputType={"number"}
                            name={"Vlhkost Prostředí"}
                            required={true}
                        />
                    </div>
                </div>
                <p
                    class="smallTitle"
                    style="margin-bottom: 10px; margin-top: 1rem;"
                >
                    Dostupné pícky
                </p>
                <div class="ovenValList">
                    <SmallTable data={avalibleEnv_Table} />
                </div>
            </div>
        </div>
        <div>
            <p class="bigText">Skupina</p>
            <div class="borderBox">
                <div class="ovenValList">
                    <SmallTable
                        data={avalibleGroup_STable}
                        funTable={avalibleGroup_STableFun}
                        noDataMesage={"Žádné skupiny"}
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="formDivider" style="padding-top: 3rem;">
        <p>Sestavy</p>
        <div />
    </div>
    <div class="envTileList">
        {#each allUsedEnv as env}
            <div
                class:activeEnv={usedEnvId === env.meta.uid}
                class="envTile borderBox"
                on:click={() => {
                    displayEnv(env);
                }}
            >
                <div class="envTileDell" on:click={() => rmEnv(env)}>
                    <span class="material-icons"> clear </span>
                </div>

                <h2>{env.meta.displayedId}</h2>
                {#if env.meta.editMode}
                    <div class="envTileForm">
                        <Select
                            name={"Wika"}
                            nullAvalible={true}
                            bind:userSelected={env.data.wika}
                            optionsList={env.avalible.wika}
                        />
                        <Select
                            name={"Etalon"}
                            nullAvalible={true}
                            bind:userSelected={env.data.ethanol}
                            optionsList={env.avalible.ethanol}
                        />
                        <Select
                            name={"Pícka"}
                            nullAvalible={true}
                            bind:userSelected={env.data.oven}
                            optionsList={env.avalible.oven}
                        />
                        <Select
                            name={"Místo Kalibrace"}
                            nullAvalible={true}
                            bind:userSelected={env.data.location}
                            optionsList={env.avalible.location}
                        />
                        <Select
                            name={"Skupina"}
                            nullAvalible={true}
                            on:change={updateAllEnv}
                            bind:userSelected={env.data.group}
                            optionsList={env.avalible.group}
                        />
                        <button
                            disabled={!Boolean(
                                env.data.wika &&
                                    env.data.ethanol &&
                                    env.data.oven &&
                                    env.data.location &&
                                    env.data.group &&
                                    envTempreture !== null &&
                                    envHumidity !== null
                            )}
                            style="margin: 0;   width: 100%;"
                            class="standartButton"
                            on:click={() => {
                                changeEnvEnableMode(env, false);
                                env.meta.editMode = env.meta.editMode; // TODO
                            }}
                        >
                            <span class="material-icons"> save </span>
                            <span> Uložit </span></button
                        >
                    </div>
                {:else if env.data && env.data.group}
                    <TripleCounter valList={env.meta.tipleCountData} />
                    <div class="envTileForm">
                        <Label name={"Wika"} xVal={env.data.wika.dbUid} />
                        <Label
                            name={"Etalon"}
                            xVal={env.data.ethanol.value.name}
                        />
                        <Label name={"Pícka"} xVal={env.data.oven.value.name} />
                        <Label
                            name={"Místo Kalibrace"}
                            xVal={env.data.location.value.name}
                        />
                        <Label
                            name={"Skupina"}
                            xVal={env.data.group.displayedId}
                        />
                        <!-- <button
                            style="margin: 17px 0 0 0; width: 100%;"
                            class="standartButton"
                            on:click={() => {
                                changeEnvEnableMode(env, true);
                                env.meta.editMode = env.meta.editMode; // TODO
                            }}
                        >
                            <span class="material-icons"> edit </span>
                            <span> Upravit </span></button
                        > -->
                    </div>
                {:else}
                    <span>Something wrong</span>
                {/if}
            </div>
        {/each}
        <div
            class="envTitleCard envAddCard"
            class:envAddCardDisabled={disableEnvAdd}
            on:click={addEnv}
        >
            <span class="material-icons"> add </span>
            <span> Přidat </span>
        </div>
    </div>
    {#if usedEnv}
        <div class="formDivider">
            <p>
                Měření -
                <strong>{usedEnv.meta.displayedId}</strong>
            </p>
            <div />
        </div>
        <Data {envObesrvable} on:newDT={onNewDataPoint} />
    {/if}
</div>

<style>
    .activeEnv {
        background: var(--prim_L4);
    }
    .defaultEnvWrap {
        display: flex;
        justify-content: space-evenly;
        flex-wrap: wrap;
    }
    .defaultEnvSelect {
        max-width: 8rem;
        width: 100%;
    }
    .defaultEnvParam {
        max-width: 10rem;
        margin-left: 1rem;
        width: 100%;
    }
    .envTile {
        position: relative;
        margin-bottom: 3rem;
    }
    .envTileDell {
        position: absolute;
        font-size: 1.5rem;
        top: 0.3em;
        right: 0.3em;
        color: var(--back_D15);
        padding: 3px;
        z-index: 10;
    }
    .envTileDell:hover {
        color: var(--back_D2);
    }
    .envTile > h2 {
        color: var(--back_D2);
        font-size: 1.1rem;
        font-weight: 300;
        margin: 0;
        margin-right: 1rem;
        user-select: all;
    }
    .envTileForm {
        padding-top: 5px;
        padding-left: 7px;
    }
    .envTileList {
        padding: 1.5rem;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }
    .envTitleCard {
        width: fit-content;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .envAddCard > .material-icons {
        font-size: 2.7rem;
        padding: 0.25em;
        margin: 0 1.2em;
        border-radius: 50%;
        color: var(--prim_D2);
        /* background: var(--prim_L4); */
        background: var(--back_D1);
        /* border: solid 1px var(--back_D1); */
    }
    .envAddCard:hover > .material-icons {
        /* border: solid 1px var(--back_D15); */
        box-shadow: var(--prim) 0 0 4px 0px;
    }
    .envAddCard > :not(.material-icons) {
        color: var(--back_D2);
        margin-top: 5px;
        font-size: 0.9rem;
        font-weight: 500;
    }
    .envAddCardDisabled {
        opacity: 0.7;
    }
    .envAddCardDisabled > span {
        color: var(--back_D12) !important;
        box-shadow: none !important;
        /* border: none !important; */
        /* TODO */
    }
    .inputList {
        padding: 1rem 4rem 0 4rem;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
    }
    .inputList > div {
        padding: 10px;
    }
    .bigText {
        font-size: 1.4rem;
        padding: 0.5rem 0 0.5rem 0.7rem;
        font-weight: 300;
        color: var(--back_D2);
        user-select: all;
    }

    .wikaValList {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
        margin-top: 1rem;
    }
    .wikaValList > div {
        margin: 10px;
    }
</style>
